import { USER_PERMISSION } from 'common/config/permission';
import { ComponentType, lazy } from 'react';
import { withLoader } from 'common/components/Loader/Loader';

// delay để hiện trang loading
const withDelay = (importFunc: () => Promise<any>, delay: number) => {
  return new Promise<{ default: ComponentType<any> }>((resolve) => {
    setTimeout(() => {
      importFunc().then((module) => resolve(module));
    }, delay);
  });
};

const lazyWithDelay = (importFunc: () => Promise<any>, delay: number = 100) =>
  lazy(() => withDelay(importFunc, delay));

// Lazy loading pages with the `withLoader` HOC
const HomePage = withLoader(
  lazyWithDelay(() => import('pages/HomePage/HomePage'))
);
const RolePage = withLoader(
  lazyWithDelay(() => import('pages/RolePage/RolePage'))
);
const RolePageDetail = withLoader(
  lazyWithDelay(() => import('pages/RolePage/RolePageDetail/RolePageDetail'))
);
const MainLayout = lazy(() => import('layouts/MainLayout/MainLayout'));
const LoginPage = withLoader(
  lazyWithDelay(() => import('pages/Auth/Login/LoginPage'))
);
const ForgotPassword = withLoader(
  lazyWithDelay(() => import('pages/Auth/ForgotPassword/ForgotPassword'))
);
const ResetPassword = withLoader(
  lazyWithDelay(() => import('pages/Auth/ResetPassword/ResetPassword'))
);
const Permission = withLoader(
  lazyWithDelay(() => import('pages/PermissionPage/PermissionPage'))
);

const SongsPage = withLoader(lazyWithDelay(() => import('pages/SongsPage')));
const ShortVideoPage = withLoader(
  lazyWithDelay(() => import('pages/ShortVideoPage'))
);
const SongManagementForm = withLoader(
  lazyWithDelay(() => import('pages/SongsPage/components/SongManagementForm'))
);
const ShortManagementForm = withLoader(
  lazyWithDelay(
    () => import('pages/ShortVideoPage/components/ShortManagementForm')
  )
);
const Error = withLoader(
  lazyWithDelay(() => import('pages/ErrorPage/[Code]/Error'))
);

const CategoryManagerPage = withLoader(
  lazyWithDelay(() => import('pages/ContentManagement/CategoryPage'))
);

const AuthorPage = withLoader(
  lazyWithDelay(() => import('pages/ContentManagement/AuthorPage'))
);

const AuthorPageDetail = withLoader(
  lazyWithDelay(() => import('pages/ContentManagement/AuthorDetailPage'))
);

const UserManagementPage = withLoader(
  lazyWithDelay(() => import('pages/UserManagement/UserManagementPage'))
);

const UserManagementDetailPage = withLoader(
  lazyWithDelay(() => import('pages/UserManagement/UserDetailPage'))
);

const UserManagementEditPage = withLoader(
  lazyWithDelay(() => import('pages/UserManagement/UserEditPage'))
);

const ContentListPage = withLoader(
  lazyWithDelay(() => import('pages/ContentProvider/ContentListPage'))
);

const ContentDetailPage = withLoader(
  lazyWithDelay(() => import('pages/ContentProvider/ContentDetailPage'))
);

const PlaylistsAlbumPage = withLoader(
  lazyWithDelay(() => import('pages/PlaylistsAlbumPage/PlaylistsAlbumPage'))
);

const PlaylistsAlbumCreatePage = withLoader(
  lazyWithDelay(() => import('pages/PlaylistsAlbumPage/PlaylistsAlbumFormPage'))
);

const ManagerPakagesPage = withLoader(
  lazyWithDelay(() => import('pages/ManagerPakagesPage/ManagerPakagesPage'))
);

const ManagerPakagesDetailPage = withLoader(
  lazyWithDelay(
    () => import('pages/ManagerPakagesPage/ManagerPakagesDetailPage')
  )
);

const ManagerTransactionPage = withLoader(
  lazyWithDelay(
    () => import('pages/ManagerTransactionPage/ManagerTransactionPage')
  )
);

const ManagerTransactionDetailPage = withLoader(
  lazyWithDelay(
    () => import('pages/ManagerTransactionPage/ManagerTransactionDetailPage')
  )
);

export const ROUTES = {
  DASHBOARD: '/dashboard',
  CATEGORY: '/category',
  SONG: '/songs',
  SONG_ADD: '/songs/create-song',
  SHORT_VIDEO: '/short-video',
  SHORT_VIDEO_ADD: '/short-video/create',
  SHORT_VIDEO_DETAIL: '/short-video/detail/:id',
  SONG_DETAIL: '/songs/detail-song/:id',
  PLAYLISTS_ALBUM: '/playlists-album',
  PLAYLISTS_ALBUM_CREATE: '/playlists-album/create',
  PLAYLISTS_ALBUM_DETAIL: '/playlists-album/:id',
  CATEGORY_ADD_SONG: '/category/create-song',
  ADMIN_PARENT: '/permission-management',
  ADMIN: '/permission-management/admin',
  ROLE: '/permission-management/role',
  ROLE_DETAIL: '/permission-management/role/:id',
  LOGIN: '/login',
  FORGOTPASSWORD: '/forgot-password',
  RESETPASSWORD: '/reset-password',
  CATEGORYMANAGER: '/category-management',
  AUTHOR: '/author-management',
  AUTHOR_DETAIL: '/author-management/:id',
  USER_MANAGEMENT: '/user-management',
  USER_MANAGEMENT_DETAIL: '/user-management/:id',
  USER_MANAGEMENT_EDIT: '/user-management/:id/edit',
  CONTENT_PROVIDER: '/content-provider',
  CONTENT_PROVIDER_DETAIL: '/content-provider/:id',
  TRANSACTION: '/transaction',
  BUY_CREDIT: '/buy-credit',
  GIFT: '/gift',
  IN_APP_PURCHASE: '/purchase',
  MANAGER_PACKAGES: '/manager-packages',
  MANAGER_PACKAGES_CREATE: '/manager-packages/create',
  MANAGER_PACKAGES_DETAIL: '/manager-packages/:id',
  MANAGER_TRANSACTION: '/manager-transactions',
  MANAGER_TRANSACTION_DETAIL: '/manager-transactions/:id',
  // ERROR phải để dưới cùng
  ERROR: '/:code',
};

export const AUTH_ROUTES = [
  ROUTES.LOGIN,
  ROUTES.FORGOTPASSWORD,
  ROUTES.RESETPASSWORD,
];

const routes = [
  {
    path: '/',
    page: HomePage,
    permission: [],
    layout: MainLayout,
  },
  {
    path: ROUTES.SONG,
    page: SongsPage,
    permission: [USER_PERMISSION.GETS_SONG],
    layout: MainLayout,
  },
  {
    path: ROUTES.SHORT_VIDEO,
    page: ShortVideoPage,
    permission: [USER_PERMISSION.GETS_SONG],
    layout: MainLayout,
  },
  {
    path: ROUTES.SONG_ADD,
    page: SongManagementForm,
    permission: [USER_PERMISSION.CREATE_SONG],
    layout: MainLayout,
  },
  {
    path: ROUTES.SHORT_VIDEO_ADD,
    page: ShortManagementForm,
    permission: [USER_PERMISSION.CREATE_SHORT_VIDEO],
    layout: MainLayout,
  },
  {
    path: ROUTES.SONG_DETAIL,
    page: SongManagementForm,
    permission: [USER_PERMISSION.GETS_SONG],
    layout: MainLayout,
  },
  {
    path: ROUTES.SHORT_VIDEO_DETAIL,
    page: ShortManagementForm,
    permission: [USER_PERMISSION.GETS_SHORT_VIDEO],
    layout: MainLayout,
  },
  {
    path: ROUTES.DASHBOARD,
    page: HomePage,
    permission: [],
    layout: MainLayout,
  },
  {
    path: ROUTES.LOGIN,
    page: LoginPage,
    permission: [],
  },
  {
    path: ROUTES.FORGOTPASSWORD,
    page: ForgotPassword,
    permission: [],
  },
  {
    path: ROUTES.RESETPASSWORD,
    page: ResetPassword,
    permission: [],
  },
  {
    path: ROUTES.ADMIN,
    page: Permission,
    permission: [USER_PERMISSION.GETS_USER],
    layout: MainLayout,
  },
  {
    path: ROUTES.ROLE,
    page: RolePage,
    permission: [USER_PERMISSION.GETS_ROLE],
    layout: MainLayout,
  },
  {
    path: ROUTES.ROLE_DETAIL,
    page: RolePageDetail,
    permission: [USER_PERMISSION.UPDATE_ROLE],
    layout: MainLayout,
  },
  {
    path: ROUTES.ERROR,
    page: Error,
    permission: [],
  },
  {
    path: ROUTES.CATEGORYMANAGER,
    page: CategoryManagerPage,
    permission: [USER_PERMISSION.GETS_CATEGORY],
    layout: MainLayout,
  },
  {
    path: ROUTES.AUTHOR,
    page: AuthorPage,
    permission: [USER_PERMISSION.GETS_ARTIST],
    layout: MainLayout,
  },
  {
    path: ROUTES.AUTHOR_DETAIL,
    page: AuthorPageDetail,
    permission: [USER_PERMISSION.UPDATE_ARTIST],
    layout: MainLayout,
  },
  {
    path: ROUTES.USER_MANAGEMENT,
    page: UserManagementPage,
    permission: [USER_PERMISSION.GETS_USER],
    layout: MainLayout,
  },
  {
    path: ROUTES.USER_MANAGEMENT_DETAIL,
    page: UserManagementDetailPage,
    permission: [USER_PERMISSION.UPDATE_USER],
    layout: MainLayout,
  },
  {
    path: ROUTES.USER_MANAGEMENT_EDIT,
    page: UserManagementEditPage,
    permission: [USER_PERMISSION.UPDATE_USER],
    layout: MainLayout,
  },
  {
    path: ROUTES.CONTENT_PROVIDER,
    page: ContentListPage,
    permission: [USER_PERMISSION.GETS_RESOURCE],
    layout: MainLayout,
  },
  {
    path: ROUTES.CONTENT_PROVIDER_DETAIL,
    page: ContentDetailPage,
    permission: [USER_PERMISSION.GETS_RESOURCE],
    layout: MainLayout,
  },
  {
    path: ROUTES.PLAYLISTS_ALBUM,
    page: PlaylistsAlbumPage,
    permission: [USER_PERMISSION.GET_ALBUM_PLAYLIST],
    layout: MainLayout,
  },
  {
    path: ROUTES.PLAYLISTS_ALBUM_CREATE,
    page: PlaylistsAlbumCreatePage,
    permission: [USER_PERMISSION.CREATE_ALBUM_PLAYLIST],
    layout: MainLayout,
  },
  {
    path: ROUTES.PLAYLISTS_ALBUM_DETAIL,
    page: PlaylistsAlbumCreatePage,
    permission: [USER_PERMISSION.GET_ALBUM_PLAYLIST],
    layout: MainLayout,
  },
  {
    path: ROUTES.MANAGER_PACKAGES,
    page: ManagerPakagesPage,
    permission: [],
    layout: MainLayout,
  },
  {
    path: ROUTES.MANAGER_PACKAGES_CREATE,
    page: ManagerPakagesDetailPage,
    permission: [],
    layout: MainLayout,
  },
  {
    path: ROUTES.MANAGER_PACKAGES_DETAIL,
    page: ManagerPakagesDetailPage,
    permission: [],
    layout: MainLayout,
  },
  {
    path: ROUTES.MANAGER_TRANSACTION,
    page: ManagerTransactionPage,
    permission: [],
    layout: MainLayout,
  },
  {
    path: ROUTES.MANAGER_TRANSACTION_DETAIL,
    page: ManagerTransactionDetailPage,
    permission: [],
    layout: MainLayout,
  },
];

export default routes;
